import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailOptin", webpackPrefetch: true */ './lazyIndex')
);

const lazyInitializeMailOptinService = new LazyAction(
    lazyModule,
    m => m.initializeMailOptinService
);

runAfterInitialRender(() => {
    lazyInitializeMailOptinService.importAndExecute();
});
